import { render, staticRenderFns } from "./TimezoneLanguage.vue?vue&type=template&id=36e2f745"
import script from "./TimezoneLanguage.vue?vue&type=script&lang=js"
export * from "./TimezoneLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports